<script>
import Paging from "@/components/Paging";
import Api from "api-client";
import {getCurrencies} from "@/cache";
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/hu";

export default {
  name: "IncomesSummary",
  components: {ToggleSwitch, Paging, DatePicker},

  data() {
    return {
      sessionStorageKey: 'incomesSummaryFilters',
      currencies: undefined,
      result: {},
      rowIdToEdit: -1,
      searchTerm: "",
      isNavOpened: false,
      isUploadOpened: false,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      payDate: null,
      showInfoModal: false,
      paidFilter: false,
      invoiceNumberFilter: "",
      filtersOpen: true,
      page: 0,
      size: 10,
      payModalIndex: null,
      tourOptions: {
        useKeyboardNavigation: true,
        highlight: true,
        labels: {
          buttonSkip: 'x',
          buttonPrevious: '<',
          buttonNext: '>',
          buttonStop: 'x'
        },
      },
      steps: [
        {
          target: '#g1',
          content: 'A vevő neve mellett a rendezetlennek jelölt számlákra és a számlaszámra is szűrhetsz.',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#g2',
          content: 'A gomb megnyomásával bezárhatod a szűrőpanelt.',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#g3-0',
          content: 'Itt láthatod a kiállított számlád alapadatait.',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#g4-0',
          content: 'Ha kipipálod, az összeg beleszámít az átalányadó alapodba.',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#g5-0',
          content: 'Ezzel jelzed, hogy ez a bevétel beleszámít az alanyi adómentes keretedbe.',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#g6-0',
          content: 'A fizetésre állítás elengedhetetlen a pontos kalkulációhoz.',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        },
        {
          target: '#g-last',
          content: 'Ha segítségre van szükséged ezt súgót bármikor elérheted az ikonra kattintva.',
          offset: -80,
          params: {
            highlight: true,
            placement: 'bottom',
          }
        }
      ]
    };
  },

  props: {
    companyId: {
      required: true,
      type: Number,
    },
    isInbound: {
      required: true,
      type: Boolean,
      default: false
    },
  },

  async mounted() {
    this.currencies = JSON.parse(await getCurrencies());
    
    if (!document.cookie.includes('incomesGuideDisabled=true')) {
      this.$tours['incomesGuide'].start();
    }
  },

  computed: {
    tourCallbacks() {
      return {
        onSkip: this.onTourFinish,
        onStop: this.onTourFinish,
        onFinish: this.onTourFinish,
      };
    },
  },

  methods: {
    doPage(data) {
      this.page = data.pagingPage - 1;
      this.size = data.pagingOffset;
      this.loadData(data.pagingPage - 1, data.pagingOffset);
    },

    loadData(page, size) {
      Api.getInvoicesOfCompany(
          'REVENUE',
          page,
          size,
          this.companyId,
          this.searchTerm || "",
          undefined,
          this.invoiceNumberFilter || "",
          undefined,
          undefined,
          this.paidFilter
      )
          .then((resp) => {
            // mock paid field for toggle switch
            resp.data.content.forEach((item) => {
              item.paid = item.modifiablePaymentDate !== null;
            });
            this.result = resp.data;
          })
          .catch((error) => {
            console.error("API hiba:", error);
            this.$toast.error({
              title: this.$cte("common.error"),
              message: this.$cte("common.error"),
            });
          });
    },

    payModal(index) {
      this.payModalIndex = index;

      if (this.result.content[index].modifiablePaymentDate) {
        this.result.content[index].modifiablePaymentDate = null;
        this.updateItem(this.result.content[index]);
      } else {
        this.payDate = null;
        this.$bvModal.show("pay-modal");
      }

    },

    modalClose() {
      this.payModalIndex = null;
      this.loadData(this.page, this.size);
    },

    savePaid() {
      if (this.payModalIndex === null || this.payModalIndex === undefined) {
        this.$toast.error({
          title: this.$cte("common.error"),
          message: "Nincs kiválasztva elem a fizetés mentéséhez.",
        });
        return;
      }

      const item = this.result.content[this.payModalIndex];
      if (!item) {
        this.$toast.error({
          title: this.$cte("common.error"),
          message: "Érvénytelen elem a fizetés mentéséhez.",
        });
        return;
      }

      if (!this.payDate) {
        this.$toast.error({
          title: this.$cte("common.error"),
          message: "Add meg a fizetés dátumát!",
        });
        return;
      }

      item.modifiablePaymentDate = this.payDate;
      this.updateItem(item);
    },

    updateItem(item) {
      Api.updateInvoiceOfCompany(item)
          .then(
              () => {
                this.loadData(this.page, this.size);
                this.$bvModal.hide("pay-modal");
              }
          )
          .catch((error) => {
            console.error("API hiba:", error);
            this.$toast.error({
              title: this.$cte("common.error"),
              message: this.$cte("common.error"),
            });
          });
    },

    convertCurrency(currency) {
      switch (currency) {
        case 'Ft':
          return 'HUF';
        case 'ft':
          return 'HUF';
        default:
          return currency;
      }
    },

    toggleFilters() {
      this.filtersOpen = !this.filtersOpen;
    },

    onTourFinish() {
      const d = new Date();
      d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
      let expires = "expires=" + d.toUTCString();
      document.cookie = "incomesGuideDisabled=true;" + expires + ";path=/";
    },

    saveFiltersToSessionStorage() {
      const filters = {
        searchTerm: this.searchTerm,
        invoiceNumberFilter: this.invoiceNumberFilter,
        paidFilter: this.paidFilter,
      };
      sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(filters));
    },

    restoreFiltersFromSessionStorage() {
      const stored = sessionStorage.getItem(this.sessionStorageKey);
      if (stored) {
        try {
          const filters = JSON.parse(stored);
          if (filters.searchTerm !== undefined) this.searchTerm = filters.searchTerm;
          if (filters.invoiceNumberFilter !== undefined) this.invoiceNumberFilter = filters.invoiceNumberFilter;
          if (filters.paidFilter !== undefined) this.paidFilter = filters.paidFilter;
        } catch (e) {
          console.error('Error restoring filters from session storage:', e);
        }
      }
    },
  },

  watch: {
    searchTerm() {
      this.saveFiltersToSessionStorage();
      this.loadData(0, 10);
    },

    paidFilter() {
      this.saveFiltersToSessionStorage();
      this.loadData(0, 10);
    },

    invoiceNumberFilter() {
      this.saveFiltersToSessionStorage();
      this.loadData(0, 10);
    }
  },

  beforeMount() {
    // Restore filters from session storage before loading data
    this.restoreFiltersFromSessionStorage();
    this.loadData(0, 10);
  }

};
</script>

<template>
  <div class="IncomesSummary_vue main-wrapper m-0 p-0 mt-3 font-jumperlight container-fluid">

    <button id="g-last" @click="$tours['incomesGuide'].start()" class="startGuideBtn"><i class="fal fa-question-circle"></i></button>
    <v-tour
        name="incomesGuide"
        :steps="steps"
        :options="tourOptions"
        :callbacks="tourCallbacks"
    ></v-tour>

    <b-modal id="pay-modal" hide-footer title="Kifizetés dátuma" @close="modalClose">
      <date-picker
          v-model="payDate"
          :format="'YYYY-MM-DD'"
          valueType="format"
          :lang="lang"
          class="d-block w-100"

      />
      <div class="mt-3 text-right">
        <b-button
            class="mx-2"
            variant="success"
            @click="savePaid"
            :disabled="!payDate"
        >
          Mentés
        </b-button>
      </div>
    </b-modal>

    <b-row class="mb-2 summaryFilters" id="g1">
      <b-col cols="12">
        <div class="px-3 pt-2">
          <b-form-input
              debounce="600"
              v-model="searchTerm"
              class="white-input d-inline-block align-middle"
              placeholder="Írd be a vevő nevét"
              style="width: calc(100% - 50px);"
          ></b-form-input>
          <button
              id="g2"
              class="btn btn-link ml-2 align-items-center bg-white p-2 border rounded-circle shadow-lg"
              @click="toggleFilters"
              aria-label="Toggle filters"
              style="vertical-align: middle; font-size: 1rem; width: 40px; height: 40px; border-color: #CED4DA !important; margin-top: -10px;"
          >
            <i class="fa-light fa-sliders"></i>
          </button>
        </div>
        <transition name="accordion-slide">
          <div v-show="filtersOpen" class="formFilters mb-2 px-3 mr-0 mr-md-5">
            <b-row class="mb-2">
              <b-col class="col-12 col-lg-6">
                <b-form-input v-model="invoiceNumberFilter" placeholder="Számlaszám" class="mb-2 white-input"/>
              </b-col>
              <b-col class="col-12 col-lg-6">
                <div class="d-flex align-items-center mt-0 mt-xl-2 ml-2 ml-xl-0 mt-2 mt-xl-2">
                  <ToggleSwitch v-model="paidFilter"/>
                  <span class="ml-2 mb-2 small">Csak rendezetlenek</span></div>
              </b-col>
            </b-row>

          </div>
        </transition>
      </b-col>
    </b-row>

<!--        <pre style="height: 200px">-->
<!--          {{ result }}-->
<!--        </pre>-->

    <div v-if="result && result.totalNumberOfElements == 0" class="mx-3">Nincsenek megjeleníthető adatok</div>
    <div v-else class="mx-3">

      <div v-for="(item, index) in result.content"
           :key="index">

        <b-row style="border-radius: 36px; background-color: #AEC0C7;" class="mb-3 p-3 shadow-lg itemRow align-items-center"
               :id="`g3-${index}`">

          <b-col class="col-6 col-xl-5">
            <b-row>
              <b-col class="col-12 col-xl-6" style="font-size: 15px;">
                <div class="mt-3 mt-xl-0">
                  {{
                    !item.partnerName ? 'Magánszemély' : ''
                  }}
                  {{
                    item.partnerName?.length > 18 ? item.partnerName.substring(0, 18) + "..."
                        : item.partnerName
                  }}
                </div>
                <div class="small text-muted">{{ item.invoiceNumber }}</div>
              </b-col>
              <b-col class="col-12 col-xl-6 pt-2 text-left text-xl-right" style="font-size: 19px; line-height: 1.2;">
                <span class="text-nowrap">{{
                    item.totalGrossAmount ? item.totalGrossAmount.toLocaleString('hu-HU') : '-'
                  }} {{ convertCurrency(item.currency) }}</span>
              </b-col>
            </b-row>
          </b-col>

          <b-col class="col-6 col-xl-3 small text-right text-xl-left">
            <b-row class="mt-3 mt-xl-0">
              <b-col class="col-12 col-lg-6">
                <div class="text-muted" style="font-size: 10px;">Kiállítás dátuma</div>
                <div>{{ item.issueDate || '-' }}</div>
              </b-col>
              <b-col class="col-12 col-lg-6">
                <div class="text-muted" style="font-size: 10px;">Kifizetés dátuma</div>
                <div>{{ item.modifiablePaymentDate || '-' }}</div>
              </b-col>
            </b-row>
          </b-col>

          <b-col class="col-12 col-xl-4 pt-0 pt-lg-1">
            <div class="d-inline-flex align-items-bottom justify-content-between w-100">

              <div class="d-flex align-items-end">
                <label class="d-flex rounded-pill border border-dark px-2 py-1 mr-3" :id="`g4-${index}`">
                  <b-form-checkbox v-model="item.atalany" @change="updateItem(item)"/>
                  <span class="small mt-1 mr-1">Átalány</span>
                </label>
                <label class="d-flex rounded-pill border border-dark px-2 py-1 mr-3" :id="`g5-${index}`">
                  <b-form-checkbox v-model="item.aam" @change="updateItem(item)"/>
                  <span class="small mt-1 mr-1">AAM</span>
                </label>
              </div>

              <div class="mt-0 mt-xl-1 d-xl-flex d-inline text-right justify-content-end p-0 p-lg-2" :id="`g6-${index}`">
                <div class="mr-1 mr-xl-3 mt-2 mt-xl-1 mb-2 mb-xl-0 small">Fizetve</div>
                <div class="" @click="payModal(index)">
                  <ToggleSwitch v-model="item.paid"/>
                </div>
              </div>

            </div>
          </b-col>

        </b-row>

      </div>

    </div>

    <paging
        v-if="result.totalNumberOfElements > 0"
        :item-per-page="result.pageSize"
        :total-rows="result.totalNumberOfElements"
        @paging-change="doPage"
    />

  </div>
</template>

<style scoped>
.main-wrapper {
  background-color: white;
  padding: 15px;
  border-radius: 5px;

}

.customTable thead {
  font-size: 11px !important;
}

button:focus {
  outline: none !important;
  box-shadow: none !important;
}

::v-deep .custom-modal-width {
  max-width: 800px !important;
  width: 800px !important;
}

@media (max-width: 768px) {
  ::v-deep .custom-modal-width {
    max-width: 96vw !important;
    width: 96vw !important;
  }

  ::v-deep .v-step__arrow:before {
    display: none;
  }
}

.accordion-fade-enter-active, .accordion-fade-leave-active {
  transition: opacity 0.3s ease;
}

.accordion-fade-enter, .accordion-fade-leave-to {
  opacity: 0;
}

.accordion-slide-enter-active, .accordion-slide-leave-active {
  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.accordion-slide-enter, .accordion-slide-leave-to {
  max-height: 0;
  opacity: 0;
}

.accordion-slide-enter-to, .accordion-slide-leave {
  max-height: 500px;
  opacity: 1;
}

::v-deep .mx-icon-calendar {
  display: none !important;
}

::v-deep .mx-input {
  margin-bottom: 0px !important;
}

.alert-info {
  background-color: #252734;
  color: white;
  border: none;
  border-radius: 32px;
}

::v-deep .alert-dismissible .close {
  margin: 21px !important;
}

.startGuideBtn {
  position: relative;
  top: -132px;
  right: 50px;
  float: right;
  cursor: pointer;
  color: #252734;
  background-color: transparent;
  border-radius: 32px;
  border: none;
  width: 40px;
  height: 40px;
  z-index: 1050;
}

::v-deep .v-step__content {
  padding: 10px;
}

::v-deep .v-step {
  background-color: white !important;
  border-radius: 24px !important;
  border: 1px solid #B6C3C8;
  color: #202020;
}

::v-deep .v-step__buttons {
  text-align: right;
}

::v-deep .v-step__button {
  color: #202020 !important;
  border-radius: 24px !important;
  border: 1px solid #B6C3C8;
  padding: 0px 10px !important;
  font-size: 16px;
  width: 36px;
  height: 36px;
}

::v-deep .v-step__arrow:before {
  border-left: 1px solid #B6C3C8;
  border-top: 1px solid #B6C3C8;
}

::v-deep .v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(255, 255, 255, .9) !important;
  border-radius: 28px;
}
</style>
